export default () => ({
    row: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    },
});
